export function applyGradingDefaults(data, condition) {
  const grading = condition === "NEW" ? "Mint (M)" : "Near Mint (NM or M-)";

  return {
    conditionMedia: grading,
    conditionSleeve: grading,
    conditionInlay: grading, // ✅ Fix here
  };
}

export const getFinalFeatures = (baseFeatures = [], condition = "USED") => {
  const cleaned = baseFeatures.filter((f) => f.toLowerCase() !== "sealed");

  if (condition?.toUpperCase() === "NEW") {
    cleaned.push("Sealed");
  }

  return [...new Set(cleaned)];
};
